//this component will use on global sales
import { Input } from 'components/elements';
import { SelectInputProps } from 'components/elements/fields/select';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext, useWatch } from 'react-hook-form';

export default function CustomerBillingSelectInput(
  props: Omit<SelectInputProps, 'options' | 'type'>,
) {
  const { t } = useTranslation();
  const {
    label = t('common:billing_to'),
    placeholder = t('common:billing_to'),
    name,
    ...rest
  } = props;
  const { control } = useFormContext();
  const customerBillingOptions = useWatch({
    control,
    name: 'customerBillingOptions',
  });

  return (
    <Input
      {...rest}
      type="select"
      name={name}
      label={label}
      placeholder={placeholder}
      options={customerBillingOptions}
    />
  );
}
